import {
  Form,
  Modal,
  Input,
  Tag
} from "antd";
import { useEffect, useState } from "react";
import StoreProductQuery from '../../components/storeProductQuery'

const ModalComponent = (props) => {
  const {
    visible = false,
    title,
    onCancel = () => {},
    onOk = () => {},
    modalData = {},
  } = props;

  const [form] = Form.useForm()
  const [initVal, setInitVal] = useState({
    status: 1,
    productName: ''
  })
  const [statusText, setStatusText] = useState()

  // 表单验证
  const validate =(val) => { 
    form.validateFields().then(res => {
      onOk(val)
    }).catch()
  }
  // 表单提交
  const submitFormVal = () => {
    const subVal = form.getFieldValue()
    console.log('11111111111111', subVal);
    let subData = {
      storeId: subVal.storeId,
      sort: subVal.sort,
      skuId: subVal.skuId
    }
    if(subVal.id){
      subData.id = subVal.id
    }
    validate(subData)
  }
  // 状态设置
  const changeStatusTag = (val) => {
    if(val == 1){
      setStatusText('上架')
    }else if(val == 0){
      setStatusText('下架')
    }else if(val == 2){
      setStatusText('紧急下架')
    }else{
      setStatusText('初始')
    }
  }
  const handlerChange = e => {
    let fieldItem = e[0]
    console.log('432421341234', fieldItem);
    if (fieldItem.name[0] === 'productDetail') {
      form.setFieldsValue(fieldItem.value)
      changeStatusTag(fieldItem.value.onlineShelves)
    }
  }

  useEffect(() => {
    changeStatusTag(modalData.onlineShelves)
    if(modalData.id){
      modalData.productDetail.id = modalData.id
    }
    form.setFieldsValue({
      ...modalData.productDetail,
      productDetail: {
        storeId: modalData.storeId ? modalData.storeId : null,
        productInfo: modalData.productDetail
          ? modalData.productDetail.outProductNo
          : modalData.outProductNo
      },
      sort: modalData.sort ? modalData.sort : null
    })
  }, [modalData])

  useEffect(() => {
    if(!visible){
      form.resetFields()
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      title={title}
      centered
      closable={false}
      maskClosable={false}
      onCancel={onCancel}
      onOk={submitFormVal}
      cancelText="取消"
      okText="确认"
    >
      <Form 
        form={form}
        onFieldsChange={handlerChange}
        labelCol={{ span: 5 }}
        initialValues={initVal}
      >
        <Form.Item name="id" style={{ display: "none" }}>
          <></>
        </Form.Item>
        <Form.Item name='productDetail' rules={[{ required: true }]}>
          <StoreProductQuery></StoreProductQuery>
        </Form.Item>
        <Form.Item
          name="name"
          label="商品名称"
          rules={[{ required: true }]}
        >
          <Input style={{width: 260}} disabled />
        </Form.Item>
        <Form.Item
          name="status"
          label="状态"
        >
          <Tag color="#fa4b54">{statusText}</Tag>
        </Form.Item>
        <Form.Item
          name="sort"
          label="排序"
          rules={[{ required: true, message: "请输入排序" }]}
        >
          <Input style={{width: 260}} placeholder="请输入" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalComponent;
